var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaximizeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2131 3.3464e-05H8.25806C7.84372 3.3464e-05 7.50812 0.335627 7.50812 0.749971C7.50812 1.16432 7.84372 1.49991 8.25806 1.49991H10.4387L7.21934 4.71944C6.92689 5.01189 6.92689 5.48625 7.21934 5.78066C7.36569 5.92689 7.55875 6 7.74997 6C7.94118 6 8.13434 5.92689 8.28059 5.78066L11.5 2.56127V4.74194C11.5 5.15628 11.8356 5.49188 12.2499 5.49188C12.6643 5.49188 12.9999 5.15628 12.9999 4.74194L13 1.78685C13 0.802539 12.1975 0 11.2131 0L11.2131 3.3464e-05Z",
    fill: "#4F6E90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.78674 13H4.74191C5.15626 13 5.49186 12.6644 5.49186 12.25C5.49186 11.8357 5.15626 11.5001 4.74191 11.5001L2.56117 11.5L5.78066 8.28056C6.07311 7.98811 6.07311 7.51375 5.78066 7.21934C5.4882 6.92689 5.01185 6.92689 4.71941 7.21934L1.49992 10.4387V8.25806C1.49992 7.84371 1.16431 7.50812 0.749959 7.50812C0.335603 7.50812 1.59907e-08 7.84371 1.59907e-08 8.25806V11.2131C-0.000130803 12.1975 0.802428 13 1.78677 13L1.78674 13Z",
    fill: "#4F6E90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximizeIcon);
export default __webpack_public_path__ + "static/media/maximize-icon.d4ebf9d86a521e651da4b6b92116c754.svg";
export { ForwardRef as ReactComponent };